import React from 'react';
import { Reveal } from './Reveal';

interface CtaBandProps {
  onRequestAccess: () => void;
  onSignIn: () => void;
}

/** Closing CTA band — solid brand blue with soft decorative circles. */
export function CtaBand({ onRequestAccess, onSignIn }: CtaBandProps) {
  return (
    <section id="cta" className="bg-bw-primary relative overflow-hidden scroll-mt-20">
      <div className="absolute -top-20 -right-16 w-[340px] h-[340px] rounded-full bg-bw-accent/15" aria-hidden="true" />
      <div className="absolute -bottom-28 -left-10 w-[280px] h-[280px] rounded-full bg-bw-sidebar/30" aria-hidden="true" />
      <Reveal className="relative max-w-[780px] mx-auto px-5 sm:px-8 py-24 sm:py-[104px] text-center">
        <h2 className="text-[clamp(34px,4.4vw,56px)] leading-[1.04] font-extrabold tracking-[-0.035em] text-white mb-5">
          Stop guessing which bids to chase.
        </h2>
        <p className="text-[19px] leading-[1.55] text-white/80 mx-auto mb-9 max-w-[540px]">
          Find the contracts worth winning, score them honestly, and write proposals you can defend —
          line by line.
        </p>
        <div className="flex flex-wrap gap-3.5 justify-center">
          <button
            onClick={onRequestAccess}
            className="text-base font-bold text-bw-primary bg-white px-8 py-4 rounded-[9px] shadow-card-hover hover:brightness-95 transition"
          >
            Request access
          </button>
          <button
            onClick={onSignIn}
            className="text-base font-semibold text-white bg-white/10 border border-white/40 px-8 py-4 rounded-[9px] hover:bg-white/20 transition"
          >
            Sign in
          </button>
        </div>
        <div className="mt-[22px] font-mono text-xs text-white/60 tracking-wide">
          Built to WCAG 2.2 AA
        </div>
      </Reveal>
    </section>
  );
}
